import React from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { AuthProvider } from './context/AuthContext';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import './styles/transitions.css';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import AnimatedRoutes from './components/AnimatedRoutes';
import ErrorBoundary from './components/common/ErrorBoundary';
import ChatBotButton from './components/layout/chatbotbutton';
function AppContent() {
  const location = useLocation();
  const isAdminDashboard = location.pathname.includes('/admin/dashboard');
  const isAuthPage = location.pathname.includes('/auth');

  return (
    <div className="App">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {!isAdminDashboard && !isAuthPage && <Header />}
      <ErrorBoundary>
        <AnimatedRoutes />
      </ErrorBoundary>
      {!isAdminDashboard && !isAuthPage && <Footer />}

      {!isAdminDashboard && !isAuthPage && (
        <>
          <div className="whatsapp-container">
            <div className="whatsapp-numbers">
              <a href="https://wa.me/201225009497" className="whatsapp-number" target="_blank" rel="noopener noreferrer">
                <span className="number-label">تواصل معنا</span>
                <span className="number">01225009497</span>
              </a>
              <a href="https://wa.me/201015758759" className="whatsapp-number" target="_blank" rel="noopener noreferrer">
                <span className="number-label">تواصل معنا</span>
                <span className="number">01015758759</span>
              </a>
              <a href="https://wa.me/201285433443" className="whatsapp-number" target="_blank" rel="noopener noreferrer">
                <span className="number-label">تواصل معنا</span>
                <span className="number">01285433443</span>
              </a>
              <a href="https://wa.me/201093888948" className="whatsapp-number complaints" target="_blank" rel="noopener noreferrer">
                <span className="number-label">الشكاوى</span>
                <span className="number">01093888948</span>
              </a>
              <a href="https://wa.me/201284845513" className="whatsapp-number owner" target="_blank" rel="noopener noreferrer">
                <span className="number-label">مدير الشركة</span>
                <span className="number">01284845513</span>
              </a>
            </div>
            <button className="whatsapp-btn" title="تواصل معنا على واتساب">
              💬
            </button>
          </div>
          <ChatBotButton />
        </>
      )}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;